import React from 'react'
import Section from '../../molecules/Section'
import { markdownify } from '../../../utils'
import { LinkList } from '../../atoms/Lists'
import styles from './Details.module.css'
import Collapse from 'rc-collapse'
import shortid from 'shortid'
require('rc-collapse/assets/index.css')

export interface DetailsProps {
  details: {
    title: string
    description: string
    items: Detail[]
  }
}

interface DetailsLink {
  title: string
  url: string
}

interface Detail {
  title: string
  description: string
  links?: DetailsLink[]
}

export default function Details({ details }: DetailsProps) {
  const { title, description, items } = details

  return (
    <Section title={title} description={description} headerCenter>
      <Collapse accordion>
        {items.map((item: Detail) => (
          <Collapse.Panel
            header={item.title}
            headerClass={styles.detailsHeader}
            key={shortid.generate()}
          >
            {markdownify(item.description)}

            {item.links && <LinkList links={item.links} />}
          </Collapse.Panel>
        ))}
      </Collapse>
    </Section>
  )
}
